"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marcellina": {
    "96d273ab": [{
      "hkey": "12b29955",
      "slug": "scalo-ferroviario",
      "name": "Scalo Ferroviario",
      "primary": true,
      "skipSearch": false
    }],
    "scalo-ferrroviario": [{
      "hkey": "12b29955",
      "slug": "scalo-ferroviario",
      "name": "Scalo Ferroviario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;